export default __webpack_public_path__ + "static/media/add-text-button.8b357a07.svg";